/**
 * Supported Chirp GraphQL Gateways
 */
export const loadBalancers = {
  APP: 'app',
  TOOLS: 'tools',
  PRIVATEHUBTEAM: 'privatehubteam'
};
export const chirpGateways = {
  APP: 'app',
  INTERNAL: 'internal',
  TEST: 'test',
  EXTERNAL: 'external'
};
export const environments = {
  QA: 'qa',
  PROD: 'prod'
};